import { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import StateButton from "../../components/state-button/StateButton";
import "./Telefonnummer.scss";
import PhoneBig from "../../assets/images/PhoneBig.png";
import BoxImg2 from "../../assets/images/BoxImg2.svg";
import Form from "react-bootstrap/Form";
import Image from "react-bootstrap/Image";
import { Link, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import iPhonePro from "../../assets/images/iPhonePro.png";
import {NotificationManager} from 'react-notifications';

import { getPhoneCountries } from "../../api/apiRequest";
import { useLangContext } from "../../context/languageContext";
import { Tag } from "../../utils/GTMPageTag";

import { useTranslation } from "react-i18next";

const Telefonnummer = () => {
  Tag("Telefonnummer")
  const { t } = useTranslation(["common","phonenumber"]);


  const navigate = useNavigate();
  const {hostLanguage} = useLangContext();
  const [selectedValue, setSelectedValue] = useState(1);
  const [countries,setCountries] = useState([]);

  // get all phone countries
  const fetchAllProductCountries = async(product_id) => {
    try
    {
      let apiRes = await getPhoneCountries(product_id);
      let responseData = await apiRes.json();
      if(responseData.res)
      {
        setCountries(responseData.data)
      }
      else
      {
        NotificationManager.error(responseData.msg,'',2000);
      }
    }
    catch(error)
    {
      console.error(error);
    }
  }
  
  useEffect(()=>{
    fetchAllProductCountries();
  },[hostLanguage])

  return (
    <div id="ProductNumber" className="MainbBody">
      <div className="InnerBannerScetion">
        <Container>
          <Row className="align-items-center">
            <Col sm={6}>
              <div className="InnerBannerScetionLft">
                <div>
                  <h5>{t('phonenumber:banner.title')}</h5>
                  <ul>
                    <li>{t('phonenumber:banner.list_0')}</li>
                    <li>{t('phonenumber:banner.list_1')}</li>
                    <li>{t('phonenumber:banner.list_2')}</li>
                  </ul>
                </div>
                <div className="BtnGrp" style={{gap:"5px"}}>
                  
                  <StateButton className="BtnGrpLoc" 
                    text={t('phonenumber:banner.button_0')} 
                    to={"/preise/telefonnummer"}
                    userTo='/LetStarted'
                  />
                  <StateButton className="BtnGrpBN" 
                    text={t('phonenumber:banner.button_1')} 
                    to={"/preise/telefonnummer"}
                    userTo='/LetStarted'
                  />
                </div>
              </div>
            </Col>
            <Col sm={6}>
              <div className="InnerBannerScetionRgt">
                <Image
                  src={PhoneBig}
                  className="PhoneBig"
                  alt="PhoneBig"
                  fluid
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="FourBoxScetion">
        <Container className="">
          <Row>
            <Col sm={4}>
              <div className="FourBoxScetionBox">
                <span>
                  {" "}
                  <Image
                    src={"/images/rufnummer-buchen.svg"}
                    className="BannerImg"
                    alt="BannerImg"
                    fluid
                  />
                </span>
                <h3>{t('phonenumber:boxes.box_0.title')}</h3>
                <div>
                  <p>{t('phonenumber:boxes.box_0.description')}</p>
                </div>
              </div>
            </Col>
            <Col sm={4}>
              <div className="FourBoxScetionBox">
                <span>
                  {" "}
                  <Image
                    src={"/images/eingehende-anrufe.svg"}
                    className="BannerImg"
                    alt="BannerImg"
                    fluid
                  />
                </span>
                <h3>{t('phonenumber:boxes.box_1.title')}</h3>
                <div>
                  <p>{t('phonenumber:boxes.box_1.description')}</p>
                </div>
              </div>
            </Col>
            <Col sm={4}>
              <div className="FourBoxScetionBox">
                <span>
                  {" "}
                  <Image
                    src={"/images/ausgehende-anrufe.svg"}
                    className="BannerImg"
                    alt="BannerImg"
                    fluid
                  />
                </span>
                <h3>{t('phonenumber:boxes.box_2.title')}</h3>
                <div>
                  <p>{t('phonenumber:boxes.box_2.description')}</p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="DigitalmailboxScetion">
        <Container>
          <Row>
            <Col sm={12}>
              <div className="DigitalmailboxScetionInner">
                <Row>
                  <Col sm={7}>
                    <div className="DigitalmailboxinLft">
                      <div>
                        <h4>{t('phonenumber:locations.title')}</h4>
                        <p>{t('phonenumber:locations.description')}</p>
                      </div>
                      <div className="DigitalmailboxinLftCheckBox">
                        <div>{t('phonenumber:locations.select')}</div>
                        <Form.Select aria-label="Default select example" value={selectedValue} onChange={(e)=>setSelectedValue(e.target.value)} >
                          <option selected hidden>{t('phonenumber:locations.select_default')}</option>
                          {countries?.map((item,index)=>{
                            return(
                              <option key={index} value={item?.id}>{item?.name}</option>
                            )
                          })}
                        </Form.Select>

                        <Button 
                          variant="primary" 
                          type="submit" 
                          className="BtnSubmit" 
                          onClick={()=>navigate("/preise/telefonnummer/"+selectedValue)}
                        >
                          {t('phonenumber:locations.button')}
                        </Button>
                      </div>
                    </div>
                  </Col>
                  <Col sm={5}>
                    <div className="DigitalmailboxinRgt">
                      <Image src={BoxImg2} className="BoxImg" alt="BoxImg" />
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="AppScetion">
        <Container>
          <Row className="align-items-center">
            <Col sm={6}>
              <Image
                src={iPhonePro}
                className="laptopbig"
                alt="LaptopBig"
                fluid
              />
            </Col>
            <Col sm={6}>
              <div className="AppScetionTxt">
                <div>
                  <h4>{t('phonenumber:app.header')}</h4>
                  <h5>{t('phonenumber:app.title')}</h5>
                </div>
                <div className="ImgGrp">
                  <span className="ImgGrpImg">
                    <Link to={"https://play.google.com/store/apps/details?id=com.cleverdomizilmail"}>
                      <Image
                        src={"/images/cleverdomizil-google-play-virtuelles-buero-app.svg"}
                        alt={t("phonenumber:app.image_alt_google")}
                      />
                    </Link>
                  </span>
                  <span className="ImgGrpImg">
                    <Link to={"https://apps.apple.com/in/app/cleverdomicile/id6502281781"}>
                      <Image
                        src={"/images/cleverdomizil-appstore-virtuelles-buero-app.svg"}
                        alt={t("phonenumber:app.image_alt_apple")}
                      />
                    </Link>
                  </span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="PlanScetion">
        <Container className="">
          <Row>
            <Col sm={12}>
              <div className="ScetionTitel">
                <h2>{t('phonenumber:geographic.title')}</h2>
              </div>
            </Col>
          </Row>
          <Row className="GeographicScetion">
            <Col sm={4}>
              <div className="GeographicScetionBox">
                <span>
                  <Image
                    src={"/images/geografisch.svg"}
                    className="BannerImg"
                    alt="BannerImg"
                    fluid
                  />
                </span>
                <h3>{t('phonenumber:geographic.box_0.title')}</h3>
                <div>
                  <p>{t('phonenumber:geographic.box_0.description')}</p>
                </div>
              </div>
            </Col>
            <Col sm={4}>
              <div className="GeographicScetionBox">
                <span>
                  <Image
                    src={"/images/national.svg"}
                    className="BannerImg"
                    alt="BannerImg"
                    fluid
                  />
                </span>
                <h3>{t('phonenumber:geographic.box_1.title')}</h3>
                <div>
                  <p>{t('phonenumber:geographic.box_1.description')}</p>
                </div>
              </div>
            </Col>
            <Col sm={4}>
              <div className="GeographicScetionBox">
                <span>
                  <Image
                    src={"/images/gebuehrenfrei.svg"}
                    className="BannerImg"
                    alt="BannerImg"
                    fluid
                  />
                </span>
                <h3>{t('phonenumber:geographic.box_2.title')}</h3>
                <div>
                  <p>{t('phonenumber:geographic.box_2.description')}</p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Telefonnummer;
